const content = {
  description:
    'This is the main Analyzer and is available in a project by default with Consilio’s standard stopwords, reserved characters, and whitespace characters. This Analyzer is applied by default to the document extracted text in the Standard Index.',
  options: [
    {label: 'Stop Words', value: '-'},
    {label: 'Alphabetical Characters', value: 'Covert to Lowercase'},
    {label: 'Whitespace Characters', value: '-'},
  ],
};

export const analyzerDetailsAccordionMocks = [
  {id: '1', title: 'Consilio Standard Text', content},
  {id: '2', title: 'Consilio Standard CJK', content},
  {id: '3', title: 'Standard Text', content},
  {id: '4', title: 'Email / URL', content},
  {id: '5', title: 'Path', content},
  {id: '6', title: 'Keyword', content},
  {id: '7', title: 'Integer', content},
  {id: '8', title: 'Custom Analyzer 1', content},
];
